// Данный объект используется для хранения иконок и прочей информации о каждой валюте
export default {
  KZT: {
    sign: "₸"
  },
  USD: {
    sign: "$"
  },
  RUB: {
    sign: "₽"
  },
  EUR: {
    sign: "€"
  }
};
